<template>
  <div class="page">
    <van-cell-group class="app-card">
      <div class="group-title">基本信息</div>
      <van-cell title="姓名" :value="detailInfo.personnelName"/>
      <van-cell title="单位" :value="detailInfo.companyName"/>
      <van-cell title="身份证号" :value="hiddenChar(detailInfo.idCard ,10, 6)"/>
      <van-cell title="合同类型" :value="detailInfo.hetongType"/>
      <van-cell title="合同开始日期" :value="detailInfo.hetongStart"/>
      <van-cell title="合同截止日期" :value="detailInfo.hetongEnd"/>
      <van-cell title="签署截止时间" :value="detailInfo.signDeadTime"/>
      <van-cell title="签署状态" :value="detailInfo.status | statusFilter"/>
      <div style="display: flex;align-items: center;justify-content: center;padding: 10px;">
        <van-button type="primary" style="margin: 0 10px;" round plain size="small" @click="showContact()">查看合同
        </van-button>
        <van-button v-if="detailInfo.status === 3" type="info" style="margin: 0 10px;" round plain size="small"
                    @click="signContact()">去签署合同
        </van-button>
      </div>
    </van-cell-group>

    <van-cell-group class="app-card">
      <div class="group-title">入职步骤</div>
      <van-steps direction="vertical" :active="activeStep">
        <van-step v-for="item in steps" :key="item.name" @click="handleClickStep(item)">
          <div>{{ item.name }}</div>
          <div style="margin-top: 8px;">{{ item.time }}</div>
        </van-step>
      </van-steps>
      <div class="group-title"></div>
    </van-cell-group>
  </div>
</template>

<style scoped>
.page {
  box-sizing: border-box;
}
</style>

<script>
import mixinLoad from '@/mixin/mixin-load.js'
import {Step as VanStep, Steps as VanSteps} from 'vant';
import {certAddList, certAddSteps, certSignUrl, certViewUrl} from "@/api/cert";
import {createFilter} from "@/utils/sys-dict";
import nativeApi from "@/utils/native-bridge";

export default {
  name: 'EsignCenterAdd',
  components: {VanStep, VanSteps},
  mixins: [mixinLoad],
  data() {
    return {
      loading: true,
      activeStep: 0,
      steps: [{
        name: '合同准备中',
        code: 1,
        time: ''
      }, {
        name: '合同准备完成',
        code: 2,
        time: ''
      }, {
        name: '个人签署',
        code: 3,
        time: ''
      }, {
        name: '单位签署',
        code: 4,
        time: ''
      }, {
        name: '签署完成',
        code: 5,
        time: ''
      }],
      addList: [],
      detailInfo: {}
    }
  },
  filters: {
    statusFilter: createFilter('contractStatus')
  },
  methods: {
    hiddenChar(str, start = 10, length = 4) {
      try {
        return `${str.substring(0, start)}******${str.substring(start + length)}`
      } catch (e) {
        return str || ''
      }
    },
    loadData() {
      this.loading = true;
      certAddList().then(({data}) => {
        if (!data || data.length === 0) {
          return;
        }
        this.addList = data;
        this.detailInfo = data[0];
        this.processSteps(data[0]);
      })
    },
    handleClickStep() {
    },
    showContact() {
      if (this.detailInfo.status < 3) {
        this.showTip("合同正在准备中");
        return;
      }
      certViewUrl({id: this.detailInfo.id}).then((rep) => {
        nativeApi.forwardPage({uri: rep.data, title: '合同详情'});
      })
    },
    signContact() {
      if (this.detailInfo.status < 3) {
        this.showTip("合同正在准备中");
        return;
      }
      certSignUrl({id: this.detailInfo.id}).then((rep) => {
        nativeApi.forwardPage({uri: rep.data});
      })
    },
    processSteps(esignRecord) {
      this.steps.forEach((step) => {
        switch (step.code) {
          case 1:
            step.time = esignRecord.createTime;
            break;
          case 2:
            step.time = esignRecord.signDeadTime || ''
            break;
          case 3:
            step.time = esignRecord.personnelSignFinishTime || ''
            break;
          case 4:
            step.time = esignRecord.signFinishTime || ''
            break;
          case 5:
            step.time = esignRecord.personnelSignFinishTime || ''
        }
      })
      if (esignRecord.status <= 1) {
        this.activeStep = 0;
      } else if (esignRecord.status === 2 || esignRecord.status === 3 || esignRecord.status === 4) {
        this.activeStep = 1;
      } else if (esignRecord.status === 5) {
        this.activeStep = 2;
      } else if (esignRecord.status === 6) {
        this.activeStep = 4;
      } else {
        this.activeStep = -1;
      }
    },
    goPage(path) {
      this.$router.push({path});
    },
  },
  created() {
    // Promise.all([this.preCheck()]).then(() => {
    // })
    this.loadData()
  }
}
</script>
